export const FETCH_TRACKING_PGS = 'trackingPGS/FETCH';
export const FETCH_TRACKING_PGS_SUCCESS = 'trackingPGS/FETCH_SUCESS';
export const FETCH_TRACKING_PGS_FAIL = 'trackingPGS/FETCH_FAIL';

const initialState = {
    isLoading: false,
    requestCompleted: false,
    trackingCode: null,
    urlTracking: null,
    deliveryForecast: null,
};

const initialAction = {};

const TrackingPGSReducer = (state = initialState, action = initialAction) => {
  switch (action.type) {
    case FETCH_TRACKING_PGS:
      return {
        ...state,
        isLoading: true,
        requestCompleted: false,
      };
    case FETCH_TRACKING_PGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        trackingCode: action.payload.trackingCode,
        urlTracking: action.payload.urlTracking,
        deliveryForecast: action.payload.deliveryForecast,
      };
    case FETCH_TRACKING_PGS_FAIL:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        error: action.payload.error,
      };
    default:
      return { ...state };
  }
};

export default TrackingPGSReducer;
